import { Link } from 'react-router-dom';
import React from 'react';
import styled from 'styled-components';
// import Headers from './header';
import { Button } from '@mui/material';
import Iframe from 'react-iframe'
import ChatbotDropdown from './ChatbotDropdown';


function AppCompiler() {
  
  return (
    <>
   
    <ComplierPage>
    {/* <Headers style={{ zIndex:"1"}}/> */}
    
    <CompilerBody>
    <Link to="/" >
  
        <Button style={{ color: '#FFF' ,
        marginLeft:"10px" ,background:"red" ,position:"relative", marginTop:"20px"}}>Back to Slack</Button>
      
    </Link>
    <ChatBotCss>
    <div>
    <ChatbotDropdown />
   </div>
   </ChatBotCss>
    <CompilerBodymargin>
     
     <div><Iframe url="https://codex.jaagrav.in/"
            width="100%"
            height="90%"
            id=""
            className=""
            display="block"
            position="absolute" /></div>
      </CompilerBodymargin>
     </CompilerBody>
     
    </ComplierPage>
    </>
    

 
 
  )
}

export default AppCompiler;



const ComplierPage = styled.div`

height: 100vh;
background-color: #1A202A;

`;

const CompilerBody = styled.div`
width: 100%;
height: 100%;


`;
 
const CompilerBodymargin=styled.div`
margin-top: 1%;
`;

const ChatBotCss=styled.div`
margin-left: 75%;
margin-top: -18px;
`;

